<template>
  <div>
    <el-form label-position="top" label-width="90px">
      <a-form-model-item label="选择触发的动作" prop="text" class="user-type">
        <a-radio-group v-model="config.type">
          <a-radio label="WEBHOOK">发送网络请求</a-radio>
          <a-radio label="EMAIL">发送邮件</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <div v-if="config.type === 'WEBHOOK'">
        <a-form-model-item label="请求地址" prop="text">
          <a-input placeholder="请输入URL地址" size="medium" v-model="config.http.url">
            <a-select v-model="config.http.method" style="width: 85px;" slot="prepend" placeholder="URL">
              <a-select-option label="GET" value="GET"></a-select-option>
              <a-select-option label="POST" value="POST"></a-select-option>
              <a-select-option label="PUT" value="PUT"></a-select-option>
              <a-select-option label="DELETE" value="DELETE"></a-select-option>
            </a-select>
          </a-input>
        </a-form-model-item>
        <a-form-model-item label="Header请求头" prop="text">
          <div slot="label">
            <span style="margin-right: 10px">Header请求头</span>
            <a-button type="text" @click="addItem(config.http.headers)"> + 添加</a-button>
          </div>
          <div v-for="(header, index) in config.http.headers" :key="header.name">
            - <a-input placeholder="参数名" size="small" style="width: 100px;" v-model="header.name" />
            <a-radio-group size="small" style="margin: 0 5px;" v-model="header.isField">
              <a-radio-button :label="true">表单</a-radio-button>
              <a-radio-button :label="false">固定</a-radio-button>
            </a-radio-group>
            <a-select v-if="header.isField" style="width: 180px;" v-model="header.value" size="small"
              placeholder="请选择表单字段">
              <a-select-option v-for="form in forms" :key="form.id" :label="form.title"
                :value="form.title"></a-select-option>
            </a-select>
            <a-input v-else placeholder="请设置字段值" size="small" v-model="header.value" style="width: 180px;" />
            <el-icon class="el-icon-delete" @click="delItem(config.http.headers, index)"
              style="margin-left: 5px; color: #c75450; cursor: pointer" />
          </div>
        </a-form-model-item>
        <a-form-model-item label="Header请求参数" prop="text">
          <div slot="label">
            <span style="margin-right: 10px">Header请求参数 </span>
            <a-button style="margin-right: 20px" type="text" @click="addItem(config.http.params)"> + 添加</a-button>
            <span>参数类型 - </span>
            <a-radio-group size="small" style="margin: 0 5px;" v-model="config.http.contentType">
              <a-radio-button label="JSON">json</a-radio-button>
              <a-radio-button label="FORM">form</a-radio-button>
            </a-radio-group>
          </div>
          <div v-for="(param, index) in config.http.params" :key="param.name">
            - <a-input placeholder="参数名" size="small" style="width: 100px;" v-model="param.name" />
            <a-radio-group size="small" style="margin: 0 5px;" v-model="param.isField">
              <a-radio-button :label="true">表单</a-radio-button>
              <a-radio-button :label="false">固定</a-radio-button>
            </a-radio-group>
            <a-select v-if="param.isField" style="width: 180px;" v-model="param.value" size="small" placeholder="请选择表单字段">
              <a-select-option v-for="form in forms" :key="form.id" :label="form.title"
                :value="form.title"></a-select-option>
            </a-select>
            <a-input v-else placeholder="请设置字段值" size="small" v-model="param.value" style="width: 180px;" />
            <el-icon class="el-icon-delete" @click="delItem(config.http.params, index)"
              style="margin-left: 5px; color: #c75450; cursor: pointer" />
          </div>
          <div>

          </div>
        </a-form-model-item>
        <a-form-model-item label="请求结果处理" prop="text">
          <div slot="label">
            <span>请求结果处理</span>
            <span style="margin-left: 20px">自定义脚本: </span>
            <el-switch v-model="config.http.handlerByScript"></el-switch>
          </div>
          <span class="item-desc" v-if="config.http.handlerByScript">
            👉 返回值为 ture 则流程通过，为 false 则流程将被驳回
            <div>支持函数
              <span style="color: dodgerblue">setFormByName(
                <span style="color: #939494">'表单字段名', '表单字段值'</span>
                )</span>
              可改表单数据
            </div>
          </span>
          <span class="item-desc" v-else>👉 无论请求结果如何，均通过</span>
          <div v-if="config.http.handlerByScript">
            <div>
              <span>请求成功😀：</span>
              <a-input type="textarea" v-model="config.http.success" :rows="3"></a-input>
            </div>
            <div>
              <span>请求失败😥：</span>
              <a-input type="textarea" v-model="config.http.fail" :rows="3"></a-input>
            </div>
          </div>
        </a-form-model-item>
      </div>
      <div v-else-if="config.type === 'EMAIL'">
        <a-form-model-item label="邮件主题" prop="text">
          <a-input placeholder="请输入邮件主题" size="medium" v-model="config.email.subject" />
        </a-form-model-item>
        <a-form-model-item label="收件方" prop="text">
          <a-select size="small" style="width: 100%;" v-model="config.email.to" filterable multiple allow-create
            default-first-option placeholder="请输入收件人">
            <a-select-option v-for="item in config.email.to" :key="item" :label="item" :value="item"></a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="邮件正文" prop="text">
          <a-input type="textarea" v-model="config.email.content" :rows="4"
            placeholder="邮件内容，支持变量提取表单数据 ${表单字段名} "></a-input>
        </a-form-model-item>
      </div>
    </el-form>
  </div>
</template>

<script>
//import { codemirror } from 'vue-codemirror'
// 引入主题 可以从 codemirror/theme/ 下引入多个
//import 'codemirror/theme/idea.css'
// 引入语言模式 可以从 codemirror/mode/ 下引入多个
//import "codemirror/mode/javascript/javascript.js"

export default {
  name: "TriggerNodeConfig",
  components: {/*codemirror*/ },
  props: {
    config: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    forms() {
      return this.$store.state.flow.design.formItems || []
    }
  },
  data() {
    return {
      cmOptions: {
        tabSize: 4, // tab
        indentUnit: 4,
        styleActiveLine: true, // 高亮选中行
        lineNumbers: true, // 显示行号
        styleSelectedText: true,
        line: true,
        foldGutter: true, // 块槽
        gutters: ['CodeMirror-linenumbers', "lock", "warn"],
        highlightSelectionMatches: { showToken: /w/, annotateScrollbar: true }, // 可以启用该选项来突出显示当前选中的内容的所有实例
        mode: 'javascript',
        // hint.js options
        hintOptions: {
          // 当匹配只有一项的时候是否自动补全
          completeSingle: false
        },
        // 快捷键 可提供三种模式 sublime、emacs、vim
        keyMap: 'sublime',
        matchBrackets: true,
        showCursorWhenSelecting: false,
        // scrollbarStyle:null,
        // readOnly:true,  //是否只读
        theme: 'material', // 主题 material
        extraKeys: { 'Ctrl': 'autocomplete' }, // 可以用于为编辑器指定额外的键绑定，以及keyMap定义的键绑定
        lastLineBefore: 0
      }
    }
  },
  methods: {
    addItem(items) {
      if (items.length > 0 && (items[items.length - 1].name.trim() === ''
        || items[items.length - 1].value.trim() === '')) {
        this.$message.warning("请完善之前项后在添加")
        return;
      }
      items.push({ name: '', value: '', isField: true })
    },
    delItem(items, index) {
      items.splice(index, 1)
    },
    onCmCodeChange() {

    },
    onCmReady() {

    }
  }
}
</script>

<style lang="less" scoped>
.item-desc {
  color: #939494;
}
</style>
